import styled from 'styled-components';
import { H2 } from '@increasecard/typed-components';
export const ColumnTitle = styled(H2)`
  margin: 0;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid ${({ theme }) => theme.colors.brandBlack.light};
`;
